import {createContext, useContext} from "react";
import {FiPlus} from "react-icons/fi";
import {components, MenuListProps} from "react-select";

import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ServiceTag} from "@/lib/types/checks.ts";

import styles from "./AnalyzerTagsMenuList.module.scss";

export const CreateTagContext = createContext<() => void>(() => {});

export const AnalyzerTagsMenuList = ({children, ...props}: MenuListProps<ServiceTag, true>) => {
  const onCreateTag = useContext(CreateTagContext);
  return (
    <div>
      <components.MenuList {...props}>{children}</components.MenuList>
      <div className={styles.createAction}>
        <Button
          variant="dropdownMenuItem"
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => {
            props.selectProps.onMenuClose();
            onCreateTag();
          }}
        >
          <Icon icon={FiPlus} size="tiny" removeDivDimensions className="me-1" />
          Create New Tag
        </Button>
      </div>
    </div>
  );
};
